// extracted by mini-css-extract-plugin
export default {"skillCardContainer":"SkillItem_skillCardContainer__vD7Pk","skillContainer":"SkillItem_skillContainer__ukebw","skillItem":"SkillItem_skillItem__fKygc"};